import { defineMessages } from 'react-intl';

export default defineMessages({
  repositoriesHeading: {
    id: 'bitkit.navigation.searchResults.repositoriesHeading',
    description: 'Heading for repository search results',
    defaultMessage: 'Repositories',
  },
  compassRequestAccess: {
    id: 'bitkit.navigation.compassTab.compassRequestAccess',
    description: 'Button text for non-admins to request access to Compass',
    defaultMessage: 'Request access to Compass',
  },
  accessRequestSentHeading: {
    id: 'bitkit.navigation.compassTab.accessRequestSentHeading',
    description: 'Header for the request access flag',
    defaultMessage: 'Access request sent',
  },
  accessRequestSentDescription: {
    id: 'bitkit.navigation.compassTab.accessRequestSentDescription',
    description: 'Description for the request access flag',
    defaultMessage: 'We’ve let your Bitbucket admin know.',
  },
  accessRequestSentHeadingError: {
    id: 'bitkit.navigation.compassTab.accessRequestSentHeadingError',
    description: 'Header for the request access flag when there is an error',
    defaultMessage: 'Error sending access request',
  },
  accessRequestSentDescriptionError: {
    id: 'bitkit.navigation.compassTab.accessRequestSentDescriptionError',
    description:
      'Description for the request access flag when there is an error',
    defaultMessage: 'Please reload the page and try again.',
  },
});
